module.exports = __webpack_public_path__ + "static/media/QuickShopImageGeneric.b0453f61.png";